const twitterIcon = ({ className }: { className: string }) => {
  return (
    <svg className={className} viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.6881 9.73893L22.2504 0H20.2214L12.7868 8.45618L6.84879 0H0L8.97943 12.7872L0 23H2.0291L9.88024 14.07L16.1512 23H23L13.6876 9.73893H13.6881ZM10.909 12.8999L9.99919 11.6266L2.76021 1.49463H5.87679L11.7187 9.67143L12.6285 10.9448L20.2224 21.5733H17.1058L10.909 12.9004V12.8999Z" fill="black"/>
    </svg>
  )
}

export default twitterIcon
